import axios from "axios";
import Config from "../../../config/index";
import {
    GET_USAGE_HISTORY_REQUEST,
    GET_USAGE_HISTORY_SUCCESS,
    GET_USAGE_HISTORY_FAILURE,
    CREATE_USAGE_HISTORY_REQUEST,
    CREATE_USAGE_HISTORY_SUCCESS,
    CREATE_USAGE_HISTORY_FAILURE,
    EDIT_USAGE_HISTORY_REQUEST,
    EDIT_USAGE_HISTORY_SUCCESS,
    EDIT_USAGE_HISTORY_FAILURE,
    DELETE_USAGE_HISTORY_REQUEST,
    DELETE_USAGE_HISTORY_SUCCESS,
    DELETE_USAGE_HISTORY_FAILURE,
} from "./usageHistoryTypes";  

let baseUrl = Config.baseUrl;
 
const getUsageHistoryRequest = () => ({ type: GET_USAGE_HISTORY_REQUEST });
const getUsageHistorySuccess = (payload) => ({ type: GET_USAGE_HISTORY_SUCCESS, payload });
const getUsageHistoryFailure = (error) => ({ type: GET_USAGE_HISTORY_FAILURE, payload: error });

 const getUsageHistory = (dppId, jwtToken) => {
    let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };
    return (dispatch) => {
        dispatch(getUsageHistoryRequest());
        let url = dppId
            ? `${baseUrl}/dpp/product_usage_history/get_dpp?dppId=${dppId}`
            : `${baseUrl}/dpp/product_usage_history/get_all`;

        return axios.get(url, headers)
            .then((response) => {
                dispatch(getUsageHistorySuccess(response.data));
                return { status: true, data: response.data };
            })
            .catch((err) => {
                dispatch(getUsageHistoryFailure(err.response));
                return { status: false, data: err.response };
            });
    };
};
 
const createUsageHistoryRequest = () => ({ type: CREATE_USAGE_HISTORY_REQUEST });
const createUsageHistorySuccess = (payload) => ({ type: CREATE_USAGE_HISTORY_SUCCESS, payload });
const createUsageHistoryFailure = (error) => ({ type: CREATE_USAGE_HISTORY_FAILURE, payload: error });

  const createUsageHistory = (payload, jwtToken) => {
    let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };
    return (dispatch) => {
        dispatch(createUsageHistoryRequest());
        let url = `${baseUrl}/dpp/product_usage_history/create`;

        return axios.post(url, payload, headers)
            .then((response) => {
                dispatch(createUsageHistorySuccess(response.data));
                return { status: true, data: response.data };
            })
            .catch((err) => {
                dispatch(createUsageHistoryFailure(err.response));
                return { status: false, data: err.response };
            });
    };
};
 
const editUsageHistoryRequest = () => ({ type: EDIT_USAGE_HISTORY_REQUEST });
const editUsageHistorySuccess = (payload) => ({ type: EDIT_USAGE_HISTORY_SUCCESS, payload });
const editUsageHistoryFailure = (error) => ({ type: EDIT_USAGE_HISTORY_FAILURE, payload: error });

  const editUsageHistory = (payload, jwtToken) => {
    let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };
    return (dispatch) => {
        dispatch(editUsageHistoryRequest());
        let url = `${baseUrl}/dpp/product_usage_history/update`;

        return axios.put(url, payload, headers)  
            .then((response) => {
                dispatch(editUsageHistorySuccess(response.data));
                return { status: true, data: response.data };
            })
            .catch((err) => {
                dispatch(editUsageHistoryFailure(err.response));
                return { status: false, data: err.response };
            });
    };
};
 
const deleteUsageHistoryRequest = () => ({ type: DELETE_USAGE_HISTORY_REQUEST });
const deleteUsageHistorySuccess = (payload) => ({ type: DELETE_USAGE_HISTORY_SUCCESS, payload });
const deleteUsageHistoryFailure = (error) => ({ type: DELETE_USAGE_HISTORY_FAILURE, payload: error });

 const deleteUsageHistory = (id, udBy, jwtToken) => {
    let headers = {
        headers: { Authorization: `Bearer ${jwtToken}` },
        data: { udBy }
    };
    return (dispatch) => {
        dispatch(deleteUsageHistoryRequest());
        let url = `${baseUrl}/dpp/product_usage_history/delete?usageHistoryId=${id}`;

        return axios.delete(url, headers)
            .then((response) => {
                dispatch(deleteUsageHistorySuccess(response.data));
                return { status: true, data: response.data };
            })
            .catch((err) => {
                dispatch(deleteUsageHistoryFailure(err.response));
                return { status: false, data: err.response };
            });
    };
};

export {getUsageHistory,createUsageHistory , editUsageHistory, deleteUsageHistory}